module.exports = __webpack_public_path__ + "static/media/punch.2811bb9c.svg";